import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div>
      @for (field of field.fieldGroup; let i = $index; track field) {
        <div
          [class]="
            'grid card border-1 border-gray-50 mb-2 m-0 ' +
            (isChildSection && i === 0 ? 'mt-2' : '')
          "
        >
          <div [class]="isChildSection ? 'col py-0 pl-0' : 'w-full'">
            <formly-field [field]="field"></formly-field>
          </div>
          <div
            [class]="
              isChildSection ? 'col-auto flex align-items-end' : 'text-right w-full'
            "
          >
            <p-button
              icon="pi pi-times"
              [label]="isChildSection ? '' : 'Remove'"
              (click)="remove(i)"
              severity="danger"
              [outlined]="isChildSection ? true : false"
              [rounded]="isChildSection ? true : false"
              styleClass="mt-2"
            />
          </div>
        </div>
      }
    </div>
    <div class="text-center mt-3">
      <p-button
        icon="pi pi-plus"
        [label]="props['addText']"
        class="p-button-link p-button-sm mb-3"
        (click)="add()"
        [styleClass]="'w-full'"
        [outlined]="isChildSection ? true : false"
      />
    </div>
  `
})
export class RepeatTypeFormlyField extends FieldArrayType implements OnInit {
  isChildSection = false;
  ngOnInit(): void {
    this.isChildSection = this.props['isChildSection'];
  }
}
